import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import { TicketNumberStatusFragment } from '../../../features/ticketNumberStatus/graphql/index';

/* Querying ticket information based on ticketId */
const GetTicketNumberDetailsQuery = gql`
  query GetTicketNumberDetails($ticketNumberId: Int!) {
    ticket_number(id: $ticketNumberId) {
      ...TicketNumberStatus
    }
  }
  ${TicketNumberStatusFragment}
`;


const marshallSingleTicketData = ({ data, ownProps }) => {
  const [ticketNumberData] = querySelector(data, '$.ticket_number', []);

  return {
    data,
    ticketNumberData,
  };
};

const queryTicketNumberDetailsData = graphql(GetTicketNumberDetailsQuery, {
  props: marshallSingleTicketData,
});

export const queryTicketNumberDetailsGQL = compose(
  queryTicketNumberDetailsData,
  queryMetaHandler,
);
